import {request, setAuthInHeader} from "@/api/request";
import Vue from 'vue'
import util from "@/mixins/util";
import {logout} from "@/mixins/Auth";

const state = {
    UserInfo: {},
    contentCreate: false
};

const getters = {
    getUserInfo: state => state.UserInfo,

};

const mutations = {
    updateUserInfo(state, obj) {
        state.UserInfo = obj.value;
    },
    resetUserInfo(state) {
        state.UserInfo = {};
    },
};

const actions = {
    setUserInfo({commit, rootState}, {token}) {
        setAuthInHeader(token);
        let params = {
            mt: 'self',
        }
        request.get('setting/admin/chk/withdraw', params).then((res) => {
            let result = res.data.Data.Result;
            if (result.Info.type > 0 && result.List.hasOwnProperty('mb_no')) {
                commit('updateUserInfo', {'value': result.List});
            } else if (result.Info.type == -102) {
                logout();
            } else {
                commit('updateUserInfo', {'value': {}})
                logout();
            }

        }, () => {
            console.log('error');
        })
    },
    changeUserInfo({commit, rootState}, {data}) {
        commit('updateUserInfo', {'value': data});
    },
    initUserInfo({commit, rootState}, {data}) {
        commit('resetUserInfo');
    },
};

export default {namespaced: true, state, getters, mutations, actions}
